import {environment} from '../../environments/environment';
import {Classdefinition} from "../model/classdefinition";
import {HttpClient} from '@angular/common/http';
import {Injectable} from "@angular/core";
import {BaseFilters} from "../commons/filters/class/BaseFilters";

@Injectable({
  providedIn: 'root'
})
export class ClassdefinitionService {
  classDefinitions: {} = {};
  fcDefinitions: {} = {};
  bDefinitions: {} = {};

  constructor(private http: HttpClient) {
  }

  getServerPath() {
    return environment.apiUrl;
  }

  load() {
    return this.http
      .get(this.getServerPath() + "/get-class-definitions")
      .toPromise()
      .then(this.extractData)
      .then((data) => {
        this.classDefinitions = data.classes;
        this.fcDefinitions = data.fcs;
        this.bDefinitions = data.bricks;

        this.enrichSelects();
      })
      .catch(err => console.log('err', err));
  }

  public getByFcName(name: string) {
    if (this.fcDefinitions[name]) {
      return this.fcDefinitions[name];
    }
    return false;
  }

  public getByBrickName(name: string) {
    if (this.bDefinitions[name]) {
      return this.bDefinitions[name];
    }
    return false;
  }

  public getByName(name: string) {
    if (this.classDefinitions[name]) {
      return this.classDefinitions[name];
    }
    return false;
  }

  public attachColDefinition(cols: BaseFilters[], classname: string): BaseFilters[] {
    this.load().then(() => {
      let fdefs: Classdefinition = this.getByName(classname);

      if (fdefs) {
        for (let i in cols) {
          let fName = cols[i].field;
          let fdefOptions = cols[i].fdef;
          if (cols[i].classname && fName.indexOf(".") >= 0) {
            let parts = fName.split(".");
            fName = parts[parts.length - 1];

            let fdefsTmp: Classdefinition = this.getByName(cols[i].classname);

            if (fdefsTmp) {
              cols[i].fdef = fdefsTmp.getFieldDefinition(fName, fdefOptions);
            }
          } else {
            if (fName) {
              let fdef = fdefs.getFieldDefinition(fName, fdefOptions);
              if (fdef) {
                cols[i].fdef = fdef;
                cols[i].classname = classname;
              }
            }
          }
          //add label as first item of select
          // if(cols[i].fdef.fieldtype == "select" || cols[i].fdef.fieldtype == "multiselect"){
          //   cols[i].fdef.selectOptions[0].label = cols[i].label;
          // }
        }
      }
      return cols;
    });

    return cols;

  }

  private extractData(res: any) {
    let data = res;
    let classDefinitions: {} = {};
    let fcDefinitions: {} = {};
    let bDefinitions: {} = {};
    for (let i in data.classes) {
      classDefinitions[i] = new Classdefinition(i, data.classes[i]);
    }
    for (let i in data.fcs) {
      fcDefinitions[i] = new Classdefinition(i, data.fcs[i]);
    }
    for (let i in data.bricks) {
      bDefinitions[i] = new Classdefinition(i, data.bricks[i]);
    }
    return {
      classes: classDefinitions,
      fcs: fcDefinitions,
      bricks: bDefinitions,
    };
  }

  public getFilterDef(
    fieldname,
    filterValue,
    classname,
    fdef,
    operator,
    startLike?
  ) {
    let filter = {};

    filter["operator"] = operator;
    filter["value"] = filterValue;
    filter["property"] = fieldname;
    filter["type"] = "string";

    if (startLike) {
      filter["startLike"] = startLike;
    }

    switch (fdef.fieldtype) {
      case "date":
      case "datetime":
        filter["type"] = "date";
        break;
      case "checkbox":
        filter["type"] = "boolean";
        break;
      case "input":
      case "textarea":
      case "wysiwyg":
      case "firstname":
      case "lastname":
      case "email":
        filter["operator"] = "LIKE";
        break;
      case "number":
      case "numeric":
        filter["type"] = "numeric";
        break;
      default:
        break;
    }

    return filter;
  }

  private enrichSelects() {
    var self = this
    Object.entries(this.classDefinitions).forEach(function callback(entry: Array<any>) {

      // const [key, value] = entry
      const value: Classdefinition = entry[1]
      const key = entry[0]

      Object.entries(value.fdef).forEach(function callback(field: Array<any>) {
        const keyField = field[0]
        const optionField: Array<any> = field[1]
        if (optionField['fieldtype'] === 'select' || optionField['fieldtype'] === 'multiselect') {
          self.classDefinitions[key]['fdef'][keyField]['optionsLabel'] = []
          optionField['options'].forEach(function (value) {
            self.classDefinitions[key]['fdef'][keyField]['optionsLabel'][value['value']] = value['key']
          })
        }
      })
    })
  }
}
